module.exports = __webpack_public_path__ + "static/img/oca-culture-report.a76e375.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/oca-culture-report.jpg
// module id = toXe
// module chunks = 0